
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Onlinecabbookingpune() {



    const cardData =
    {
        keyword: ' Online Cab Booking Pune',
        heading: 'Prince Cabs: Online Cab Booking Pune',
        headingDescription: 'Prince Cabs makes travel easy with fast and reliable Online Cab Booking in Pune, perfect for local rides, airport transfers, corporate travel, family trips, and outstation journeys. Our well-maintained fleet of sedans, SUVs, and luxury cars ensures a safe, comfortable, and affordable ride for every travel need. With user-friendly booking, professional drivers, flexible schedules, and on-time service, we provide a seamless travel experience. Choose Prince Cabs’ trusted online cab booking in Pune for convenience, safety, and reliability at your fingertips.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the seat of the Peshwas and remains Pune’s most iconic historical landmark. Though partially destroyed by fire, its grand gates, fortified walls, and sprawling gardens still stand strong. The evening light-and-sound show narrates Maratha history in an engaging way. Its stories of bravery, politics, and legends attract history buffs. Shaniwar Wada is a proud reminder of Pune’s glorious past. It is a must-visit for anyone exploring the city’s heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, Aga Khan Palace is a majestic monument associated with India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace houses a museum with artifacts, personal items, and photographs from Gandhi’s life. Its lush gardens and peaceful environment make it a favorite among visitors. The site combines architecture, history, and patriotism. It is a national treasure and UNESCO-recognized heritage landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is a historic hill fortress known for the Battle of Sinhagad in 1670. The fort’s ruins, bastions, and memorials tell tales of Maratha bravery. Trekkers enjoy the scenic climb, especially during monsoon when waterfalls and mist cover the hills. From the top, visitors enjoy panoramic views of the Sahyadri ranges. Traditional snacks like pithla-bhakri are sold at the summit. It is a blend of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous temple, attracting thousands of devotees daily. The idol of Lord Ganesha is beautifully adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the heart of Pune’s celebrations with grand decorations and cultural programs. The temple is also known for its charitable activities. Its central location makes it easily accessible to tourists. It is a spiritual landmark deeply woven into Pune’s identity."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of the highest points in Pune, offering panoramic views of the city. At the summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. The climb of over 100 steps is rewarded with serene vistas and a peaceful environment. The Peshwa Museum nearby showcases artifacts from the Maratha era. Sunrises and sunsets here are especially captivating. It is both a religious and recreational attraction for locals and tourists."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, dating back to the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Carved out of a single basalt rock, it features intricate pillars, a sanctum with a Shiva linga, and unfinished structures. The temple is a fine example of Rashtrakuta architecture. Despite being in the city center, it offers a calm and spiritual environment. Visitors admire its historic and architectural significance. It is a hidden gem for history enthusiasts."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum displays over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, paintings, sculptures, and everyday objects from across India. Highlights include the Mastani Mahal, a reconstruction of Mastani’s palace. The museum reflects India’s diverse cultural heritage. It fascinates both children and adults with its rare collections. It is one of Pune’s best spots for art and history lovers."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from around the globe come here for meditation, yoga, and wellness programs. The ashram is set amidst lush gardens and modern facilities, creating a serene environment. It promotes holistic well-being and self-discovery. The community vibe and international presence add cosmopolitan charm. It is a unique destination blending spirituality with modernity."
  },
  {
    "title": "Phoenix Marketcity Pune",
    "description": "Phoenix Marketcity is Pune’s largest shopping and lifestyle mall, located in Viman Nagar. It houses hundreds of international and Indian brands, making it a shopper’s paradise. Entertainment options include multiplex cinemas, gaming zones, and live events. The mall also has a wide range of restaurants, bars, and cafés. Seasonal events like Christmas and Diwali celebrations make it lively. It is the perfect spot for shopping, dining, and leisure under one roof."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, situated about 20 km from Pune, is a popular picnic and weekend spot. The reservoir provides water to the city and offers scenic beauty with surrounding hills. Visitors enjoy boating, evening walks, and local street food like corn and bhajis. Monsoon enhances its charm with mist and greenery. Families flock here to relax away from city life. It is one of Pune’s most-loved natural retreats."
  },
  {
    "title": "Mulshi Lake and Dam",
    "description": "Mulshi Lake, located 40 km from Pune, is a tranquil destination surrounded by Sahyadri mountains. It is popular for camping, boating, and nature walks. During monsoon, waterfalls and lush landscapes make it enchanting. Eco-resorts around the lake offer a comfortable stay amidst nature. It is also a great photography and trekking spot. Mulshi is perfect for those seeking peace and adventure close to Pune."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, located on Senapati Bapat Road, is one of Pune’s oldest temples dedicated to Goddess Chaturshringi (Durga). Devotees climb over 100 steps to reach the hilltop shrine. The temple is especially vibrant during Navratri with grand decorations and celebrations. It attracts thousands of devotees from across Maharashtra. The panoramic views from the temple add to its charm. It remains a key religious and cultural landmark in Pune."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This memorial in Pune honors Indian soldiers who sacrificed their lives in various wars. It features a museum with artifacts, tanks, and war memorabilia. The evening flag retreat ceremony fills visitors with pride and patriotism. The memorial is surrounded by a peaceful park, making it a reflective spot. It is both educational and inspiring for families and students. It stands as a tribute to India’s armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread over 39 acres, is a botanical paradise maintained by the Agri-Horticultural Society. It is home to rare trees, plants, and beautiful flower nurseries. Families enjoy picnics under its shady trees. Annual flower shows attract garden enthusiasts. Its peaceful environment makes it a favorite among locals. It is an oasis of greenery within busy Pune city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi is Pune’s highest point, offering trekking trails, sunrise views, and fresh air. Popular among fitness enthusiasts, it has multiple routes for jogging and cycling. The hill is rich in biodiversity with birds and small wildlife. Locals love it for morning walks and yoga sessions. The hilltop provides panoramic views of the entire city. It is Pune’s green lung and a natural escape."
  }
],


"services": [
    {
        "name": "Cab Service Near Me",
        "description": "Quickly find and book reliable cab services near your location in Pune. Whether you need a ride for local travel, office commute, or an urgent trip, our nearby cab services ensure prompt arrival, professional drivers, and clean, comfortable vehicles for every ride."
    },
    {
        "name": "Cab Company Near Me",
        "description": "Looking for trusted cab companies nearby? We partner with top-rated cab providers across Pune to bring you quality transportation with verified drivers, GPS-enabled vehicles, and 24/7 customer support for safe and dependable travel solutions."
    },
    {
        "name": "Taxi Cab Near Me",
        "description": "Get instant access to nearby taxi cabs in Pune with our location-based cab locator. Whether you’re heading to a meeting, airport, or social event, our nearby taxi options offer fast pickups, courteous service, and competitive pricing."
    },
    {
        "name": "Call Taxi Near Me",
        "description": "Need a taxi urgently? Call taxi services near you in Pune are just a few clicks away. Our fleet is always ready for quick dispatch with well-maintained vehicles and trained drivers, ensuring timely pickups and secure transportation."
    },
    {
        "name": "Cab Booking Near Me",
        "description": "Easily book a cab near your location in Pune for local or outstation travel. With real-time availability, instant confirmation, and multiple vehicle options, our platform simplifies booking and guarantees a comfortable and reliable journey every time."
    },
    {
        "name": "Taxi Booking Near Me",
        "description": "Find fast and easy taxi booking options near your area in Pune. From compact cars to premium sedans, choose the right vehicle and enjoy a safe ride with transparent pricing, professional drivers, and smooth service, day or night."
    },
    {
        "name": "Outstation Taxi Service Near Me",
        "description": "Book trusted outstation taxi services near your location in Pune for weekend getaways, business trips, or family vacations. Our outstation cabs are available for immediate dispatch with experienced drivers, clean interiors, and flexible travel plans."
    },
    {
        "name": "Online Taxi Booking Pune",
        "description": "Enjoy the convenience of online taxi booking in Pune with just a few taps. Compare vehicle types, fares, and availability instantly. Our online system is fast, reliable, and secure, offering you peace of mind and a stress-free ride."
    },
    {
        "name": "Online Car Booking Pune",
        "description": "Book cars online in Pune for local and outstation travel with ease. Choose from a wide range of vehicles including sedans, SUVs, and premium cars, all driven by courteous professionals committed to making your trip safe and comfortable."
    },
    {
        "name": "Online Cab Service in Pune",
        "description": "Get access to the best online cab services in Pune with multiple travel options, instant confirmations, and real-time tracking. Whether you're commuting daily or planning a long trip, our digital booking platform ensures seamless service at your fingertips."
    },
    {
        "name": "Online Cabs in Pune",
        "description": "Explore a variety of online cab options in Pune with flexible pricing, fast bookings, and trustworthy drivers. From budget rides to luxury travel, book your preferred cab instantly and travel across Pune or beyond without any hassle."
    },
    {
        "name": "Affordable Cab Booking Pune",
        "description": "Book affordable cabs in Pune without compromising on comfort or safety. Our platform provides budget-friendly travel solutions with well-maintained cars, transparent fare systems, and prompt service tailored for everyday and long-distance travel."
    },
    {
        "name": "Luxury Taxi Booking Pune",
        "description": "Experience premium travel in Pune with our luxury taxi booking services. Choose from high-end vehicles like Innova Crysta, sedans, and executive cars, perfect for business meetings, special events, and airport transfers with a touch of elegance."
    },
    {
        "name": "Pune Online Cab Fare",
        "description": "Check accurate and updated online cab fares in Pune across different vehicle types and routes. Our transparent fare estimates help you plan your travel budget better with no hidden charges or surprises at the end of your trip."
    },
    {
        "name": "Pune Airport Online Cab Booking",
        "description": "Easily book cabs online for Pune Airport pickups and drop-offs. Choose from multiple vehicle options, get real-time driver tracking, and enjoy timely, comfortable airport transfers with dedicated airport cab services available 24/7."
    }
],
"tableData": [
    ["Cab Service Near Me", "Cab Company Near Me"],
    ["Taxi Cab Near Me", "Call Taxi Near Me"],
    ["Cab Booking Near Me", "Taxi Booking Near Me"],
    ["Outstation Taxi Service Near Me", "Online Taxi Booking Pune"],
    ["Online Car Booking Pune", "Online Cab Service in Pune"],
    ["Online Cabs in Pune", "Affordable Cab Booking Pune"],
    ["Luxury Taxi Booking Pune", "Pune Online Cab Fare"],
    ["Pune Airport Online Cab Booking", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Fast and Reliable Online Cab Booking in Pune",
        "WhyChoosedescription": "Prince Cabs makes booking a cab in Pune effortless and quick with our seamless online cab reservation system. Whether you need a cab for a few hours, a full day, airport pickup, or an outstation trip, our platform allows you to book instantly with just a few clicks—anytime, from anywhere."
    },
    {
        "WhyChooseheading": "Wide Range of Well-Maintained Vehicles Available Online",
        "WhyChoosedescription": "Choose from our diverse fleet of vehicles including hatchbacks, sedans, SUVs, and tempo travellers—directly through our website or WhatsApp. All cabs are air-conditioned, clean, and regularly serviced to ensure a safe and comfortable ride within Pune or to outstation destinations."
    },
    {
        "WhyChooseheading": "Professional Drivers with Punctual and Courteous Service",
        "WhyChoosedescription": "Every online booking through Prince Cabs comes with a trained, verified, and experienced driver who values your time and safety. Our drivers are punctual, polite, and familiar with Pune’s routes and traffic patterns, ensuring a smooth and reliable journey from pickup to drop-off."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Every Travel Need",
        "WhyChoosedescription": "Book a cab online for one-way trips, round trips, hourly rentals, airport transfers, or outstation journeys. Whether it's an early morning flight, a quick city errand, or a weekend getaway, our booking options are designed to suit every traveler’s schedule and convenience."
    },
    {
        "WhyChooseheading": "Sanitized Vehicles and Safety Assured",
        "WhyChoosedescription": "All our cabs are thoroughly sanitized before and after every ride. Safety is our top priority—vehicles are equipped with seat belts, GPS tracking, and first-aid kits, and we strictly follow hygiene protocols to ensure passenger well-being at every step of the journey."
    },
    {
        "WhyChooseheading": "Transparent Online Pricing with No Hidden Charges",
        "WhyChoosedescription": "With Prince Cabs, what you see is what you pay. Our online booking system provides real-time fare estimates with no hidden fees or last-minute surprises. You can pay securely through UPI, debit/credit cards, net banking, or cash as per your preference."
    },
    {
        "WhyChooseheading": "24/7 Online Customer Support",
        "WhyChoosedescription": "Need help with your booking, payment, or trip details? Our online customer support team is available 24/7 to resolve queries, assist with rescheduling, and ensure that your entire cab booking experience in Pune is smooth, fast, and worry-free."
    }
]

























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer online cab booking in Pune?',
        answer: 'Yes, Prince Cabs provides a simple and fast online cab booking service in Pune. You can book your ride through our website or by calling our support team.',
    },
    {
        question: 'What types of cabs can I book online in Pune?',
        answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers—suitable for local, airport, and outstation travel.',
    },
    {
        question: 'Is online cab booking with Prince Cabs available 24/7?',
        answer: 'Yes, our online booking system is available 24/7. You can book a cab anytime for immediate or scheduled pickup across Pune.',
    },
    {
        question: 'Can I book both local and outstation cabs online?',
        answer: 'Absolutely! Prince Cabs allows you to book local hourly rentals, airport transfers, and outstation round-trips or one-way rides online with ease.',
    },
    {
        question: 'Is online cab booking secure and reliable?',
        answer: 'Yes, our online booking process is secure, transparent, and user-friendly. You receive instant confirmation and driver details before the trip.',
    },
    {
        question: 'Do I get to choose the cab type while booking online?',
        answer: 'Yes, while booking online, you can choose your preferred cab type based on the number of passengers and your travel comfort requirements.',
    },
    {
        question: 'Can I modify or cancel my online cab booking?',
        answer: 'Yes, Prince Cabs offers flexible booking management. You can modify or cancel your booking easily through our customer support.',
    },
];

const testimonials = [
    {
        name: "Mr. Rajat Karmarkar",
        position: "IT Professional",
        text: "I booked a cab online with Prince Cabs for a meeting in Pune. The process was smooth and the cab arrived on time. Very professional service!",
        image: "/img/testimonial/testimonial-thumb-online-1.png",
    },
    {
        name: "Ms. Pooja Naik",
        position: "Frequent Traveler",
        text: "Loved the convenience of booking my outstation trip online with Prince Cabs. Great UI, instant confirmation, and reliable service.",
        image: "/img/testimonial/testimonial-thumb-online-2.png",
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Pune",
  "image": "https://princecab.com/assets/images/online-cab-booking-pune.jpg",
  "description": "Book online cab service in Pune with Prince Cabs for affordable, reliable, and convenient taxi rides. Available 24/7 with luxury and budget options. Easy online booking and quick response.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/online-cab-booking-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Online Cab Booking Pune | Affordable & Reliable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers easy and reliable online cab booking in Pune with affordable and luxury taxi options available 24/7. Book your taxi online now."
  />
  <meta
    name="keywords"
    content="Cab Service Near Me, Cab Company Near Me, Taxi Cab Near Me, Call Taxi Near Me, Cab Booking Near Me, Taxi Booking Near Me, Outstation Taxi Service Near Me, Online Taxi Booking Pune, Online Car Booking Pune, Online Cab Service in Pune, Online Cabs in Pune, Affordable Cab Booking Pune, Luxury Taxi Booking Pune, Pune Online Cab Fare, Pune Airport Online Cab Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onlinecabbookingpune;